import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchWorkers } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
// import Pagination from "../common/Pagination";
import { fabStyle } from "../common/style";

const WorkerList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector(
    (state) => state.worker.workers || { count: 0, rows: [] }
  );
  const { user } = useSelector((state) => state.auth);

  // useEffect(() => {
  //   dispatch(fetchWorkers({ page, limit }));
  // }, [dispatch, page]);

  useEffect(() => {
    if (user) {
      dispatch(fetchWorkers({ page, limit }));
    }
  }, [dispatch, user, page]);

  const navigateToWorkerDetail = (id) => {
    navigate(`/workers/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderWorkers = () =>
    rows.map((worker) => (
      <TableRow
        key={worker.id}
        onClick={() => navigateToWorkerDetail(worker.id)}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{worker.name}</TableCell>
        {/* <TableCell>{worker.Application.Organization.displayName}</TableCell> */}
        <TableCell>{worker.Application.description}</TableCell>
        <TableCell>{worker.WorkerLanguage.language}</TableCell>
        <TableCell>{worker.phone}</TableCell>
        <TableCell>
          {worker.Attendances.length
            ? worker.Attendances[0].attended
              ? "출근"
              : "퇴근"
            : "-"}
        </TableCell>
        <TableCell>{new Date(worker.createdAt).toLocaleString()}</TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            작업자 현황 (총 {count}명)
          </Typography>
          <p />

          <TableContainer component={Paper}>
            <Table
              aria-label="worker-list table"
              sx={{ minWidth: 650, borderRight: 0 }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>이름</TableCell>
                  {/* <TableCell>건설사</TableCell> */}
                  <TableCell>협력사</TableCell>
                  <TableCell>언어</TableCell>
                  <TableCell>전화번호</TableCell>
                  <TableCell>상태</TableCell>
                  <TableCell>등록일시</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>{renderWorkers()}</TableBody>
            </Table>
          </TableContainer>
          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/workers/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default WorkerList;
